export default __webpack_public_path__ + "static/media/share.e955fd3a.svg";